import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import styles from '../../../../components/advertiserBrand/styles.module.css'
import { countImportRowStatuses } from '../../../../helpers/advertiserBrandImport'
import { Chip } from './Chip'
import { ReviewRow } from './reviewRows'

/** Contagem por desfecho; sem nenhum fato do dry-run, só o total de válidas. */
export const ReviewSummary: React.FC<{
  rows: ReviewRow[]
  valid: number
}> = ({ rows, valid }) => {
  const { t } = useAPPTranslation()
  const counts = countImportRowStatuses(rows.map(row => row.status))
  const allUnknown = !!counts.unknown && counts.unknown === rows.length

  return (
    <output className={styles.reviewSummary}>
      {allUnknown && (
        <Chip
          tone="link"
          label={t('rm:advertiserProducts.import.review.valid', {
            count: valid
          })}
        />
      )}

      {!!counts.add && (
        <Chip
          tone="add"
          label={t('rm:advertiserProducts.import.review.count.add', {
            count: counts.add
          })}
        />
      )}

      {!!counts.link && (
        <Chip
          tone="link"
          label={t('rm:advertiserProducts.import.review.count.link', {
            count: counts.link
          })}
        />
      )}

      {!!counts.move && (
        <Chip
          tone="move"
          label={t('rm:advertiserProducts.import.review.count.move', {
            count: counts.move
          })}
        />
      )}

      {!!counts.unchanged && (
        <Chip
          tone="unchanged"
          label={t('rm:advertiserProducts.import.review.count.unchanged', {
            count: counts.unchanged
          })}
        />
      )}

      {!!counts.unknown && !allUnknown && (
        <Chip
          tone="unknown"
          label={t('rm:advertiserProducts.import.review.count.unknown', {
            count: counts.unknown
          })}
        />
      )}

      <Chip
        tone={counts.error ? 'error' : 'unchanged'}
        label={t('rm:advertiserProducts.import.review.errors', {
          count: counts.error
        })}
      />
    </output>
  )
}
